import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { DEMO_URL_PARAM_KEYS } from 'tio-employee/utils/career-pathways-demo-data';

export default class AuthenticatedSlrController extends Controller {
  queryParams = [...DEMO_URL_PARAM_KEYS];

  @tracked demo = '';
  @tracked demo_client = '';
  @tracked demo_product = '';
  @tracked demo_role = '';
  @tracked demo_scenario = '';
  @tracked demo_user_scenario = '';
  @tracked demo_ta_payment_model = '';
  @tracked demo_debt = '';
  @tracked demo_ta_scenario = '';
  @tracked demo_pslf_scenario = '';
  @tracked demo_document_status = '';
}
